<template>
    <div class="absolute shadow-lg bg-white p-4 w-[calc(100%-2rem)] left-4 z-50"
         :class="[{'hidden': !visible}, $widgetConfig.staticAudience ? 'top-4' : 'top-[50px]']">
        <h4 class="font-bold text-[18px] mb-4">Are You Sure?</h4>
        <p class="leading-snug">If you switch to a different data source, selects you’ve already made will be lost.</p>
        <div class="flex justify-end">
            <button
                type="button"
                class="py-2 px-6 text-white bg-primary hover:bg-primary-hover font-semibold"
                @click="submit">
                Yes
            </button>
            <button
                type="button"
                class="py-2 px-6 text-white bg-danger ml-3 hover:bg-danger-hover font-semibold"
                @click="cancel">
                No
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "confirmation-tooltip",
        props: {
            visible: {
                type: Boolean
            }
        },
        computed: {
            confirmationBase () {
                return this.$store.getters["others/getConfirmationBase"];
            }
        },
        methods: {
            submit () {
                this.$store.commit("widgetData/setAudience", this.confirmationBase);
                this.$store.commit("others/setConfirmationTooltip", false);
            },
            cancel () {
                this.$store.commit("others/setLoading", false);
                this.$store.commit("others/setConfirmationTooltip", false);
            }
        }
    };
</script>
